var map = {
	"./ID/en.md": [
		44206,
		4206
	],
	"./ID/id.md": [
		80428,
		428
	],
	"./MY/en-my.md": [
		66164,
		6164
	],
	"./SG/en-sg.md": [
		32296,
		2296
	],
	"./VN/en.md": [
		70217,
		217
	],
	"./VN/vi.md": [
		52143,
		2143
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 46542;
module.exports = webpackAsyncContext;